// frontend/src/components/Auth/CoachRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../Common/LoadingSpinner';

const CoachRoute = ({ redirectPath = '/', children }) => {
  const { user, loading, isCoach } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullScreen message="Checking permissions..." />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isCoach) {
    // User is authenticated but not a coach
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export default CoachRoute;